import React from 'react';
import { ScoreDefinition } from 'utils/types';
import InterventionView from './InterventionView';
import { Table, Icon } from 'semantic-ui-react';
import commonCss from './Common.scss';

export default class ScoreDefinitionView extends React.Component {

  constructor() {
    super();
    this.state = { hideInterventions: true };
  }

  get interventions() {
    return this.props.scoreDefinition.predictor ? this.props.scoreDefinition.predictor.interventions : [];
  }

  get scoreTypeClass() {
    return (Math.sign(this.props.scoreDefinition.weight) === 1) ? 'positive' : 'negative';
  }

  get scoreTypeIconName() {
    return this.scoreTypeClass === 'positive' ? "plus circle" : "minus circle";
  }

  render() {
    return (
      <Table.Row>
        <Table.Cell className={commonCss['centered']}>
          <Icon className={commonCss[this.scoreTypeClass]} name={this.scoreTypeIconName} size="large" />
        </Table.Cell>
        <Table.Cell className={commonCss['pad-md']}>{this.props.scoreDefinition.name}</Table.Cell>
        <Table.Cell className={commonCss['centered']}>{this.props.scoreDefinition.value}</Table.Cell>
        <Table.Cell className={commonCss['pad-md']}>
          {this.interventions.map(intervention => {
            return <InterventionView key={intervention.interventionId} intervention={intervention} />;
          })}
        </Table.Cell>
      </Table.Row>
    );
  }
}

ScoreDefinitionView.propTypes = {
  scoreDefinition: ScoreDefinition.isRequired
};
